export const BLOCK_TEXT = {
  TITLE: 'Mã đơn hàng',
  ADDRESS_TITLE: 'Địa chỉ người nhận',
};

export const BLOCK_ADDRESS = {
  TITLE: 'Địa chỉ người nhận',
  ADDRESS: 'Địa chỉ',
  PHONE: 'Điện thoại',
};

export const BLOCK_BILLING = {
  TITLE: 'Thông tin hoá đơn',
  COMPANY_NAME: 'Tên công ty',
  COMPANY_TAX: 'Mã số thuế',
  COMPANY_ADDRESS: 'Địa chỉ',
};

export const NOT_FOUND = 'Không có thông tin';

export const BLOCK_SHIPPING = {
  TITLE: 'Hình thức giao hàng',
};

export const BLOCK_PAYMENT = {
  TITLE: 'Hình thức thanh toán',
};

export const ADDRESS_LIST = {
  HEADER: {
    PRODUCT: 'Sản phẩm',
    PRICE: 'Đơn giá',
    QUANTITY: 'Số lượng',
    DISCOUNT: 'Giảm giá',
    TOTAL: 'Thành tiền',
  },
};

export const SUMMARY = {
  NOTE: 'Ghi chú',
  TOTAL_PRICE: 'Tổng tiền',
  SHIPPING_FEE: 'Phí vận chuyển',
  DISCOUNT: 'Giảm giá',
  TAX: 'Thuế GTGT',
  TOTAL_AMOUNT: 'Tổng thanh toán',
};

export const ORDER_STATUS = {
  '0': 'Mới',
  '1': 'Nháp',
  '2': 'Đang xử lý',
  '3': 'Đang soạn hàng',
  '4': 'Thiếu hàng',
  '5': 'Đủ hàng',
  '6': 'Đã đóng gói',
  '7': 'Đang giao',
  '8': 'Đã giao (thành công)',
  '9': 'Đã soạn xong',
  '-1': 'Huỷ',
};

export const PAYMENT_METHOD = {
  COD: 'Thanh toán khi nhận hàng',
  BT: 'Chuyển khoản',
};
